var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
import isEqual from 'lodash.isequal';
import { name } from './constants';
var initialState = {
    data: {},
    meta: {},
    loading: 'idle',
    error: null,
};
export var games = createSlice({
    name: name,
    initialState: initialState,
    reducers: {
        getSingleGameSuccess: function (state, action) {
            state.loading = 'fulfilled';
            state.data = __assign(__assign({}, state.data), { game: action.payload });
            state.error = null;
        },
        setGameBalance: function (state, _a) {
            var payload = _a.payload;
            return __assign(__assign({}, state), { data: __assign(__assign({}, state.data), { gameBalance: payload }) });
        },
        setActiveGame: function (state, _a) {
            var payload = _a.payload;
            if (isEqual(state.data.activeGame, payload)) {
                return state;
            }
            return __assign(__assign({}, state), { data: __assign(__assign({}, state.data), { activeGame: payload }) });
        },
        setTournamentParams: function (state, _a) {
            var payload = _a.payload;
            var pathname = payload.pathname;
            return __assign(__assign({}, state), { meta: __assign(__assign({}, state.meta), { tournament: { pathname: pathname } }) });
        },
        setDefaultGameUid: function (state, _a) {
            var payload = _a.payload;
            return __assign(__assign({}, state), { meta: __assign(__assign({}, state.meta), { defaultGameUid: payload }) });
        },
    },
});
export var getSingleGameSuccess = (_a = games.actions, _a.getSingleGameSuccess), setGameBalance = _a.setGameBalance, setActiveGame = _a.setActiveGame, setTournamentParams = _a.setTournamentParams, setDefaultGameUid = _a.setDefaultGameUid;
